import { Component, OnInit, Input } from '@angular/core';
import { Info, IInfo } from 'src/app/core/common/index';
@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  constructor() { }
  @Input() infoMessage: IInfo;
  ngOnInit() {

  }
 
}
